<template>
  <el-aside :style="isCollapse?'width:64px':'width:250px'">
    <el-menu :default-active="defaultPath" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSelect" router="" style="height:100%" active-text-color="#0090fc" :collapse="isCollapse">
      <h5>设备管理</h5>
      <el-menu-item index="/Overview">
        <i class="el-icon-menu"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="/Details">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>详细信息</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="'/Details#'+index" v-for="(item, index) in deviceTypeList" :key="index">{{item.Category}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: 'Slidebar',
  data () {
    return {
      deviceTypeList: [],
      defaultPath: '/Overview'
      // deviceTypeList: [
      //   {name: '全部', index: 0},
      //   {name: '功能服务器', index: 1},
      //   {name: '多功能教学终端', index: 2},
      //   {name: '移动导播台', index: 3},
      //   {name: '摄像机', index: 4},
      //   {name: '定位主机', index: 5}
      // ]
    }
  },
  // watch () {},
  computed: {
    isCollapse () {
      return this.$store.state.isCollapse
    }
  },
  mounted () {
    this.defaultPath = this.$route.fullPath
    this.getDeviceType()
    this.setDeviceCategoryIndex(this.$route.fullPath)
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key)
    },
    handleClose (key, keyPath) {
      console.log(key)
    },
    handleSelect (key, keyPath) {
      if (keyPath[0] === '/Overview') {
        this.$store.state.headTitle = '概况'
      } else {
        this.$store.state.headTitle = '详细信息'
      }
      this.setDeviceCategoryIndex(key)
    },
    setDeviceCategoryIndex (path) {
      let index = path.split('#')[1]
      this.$store.state.deviceCategory = index
    },
    getDeviceType () {
      this.$http.post('/Device/GetDeviceType', {}).then(res => {
        this.deviceTypeList = [{Category: '全部'}]
        let lastName = '' // 数据类型名称
        if (res.body.Success) {
          res.body.Value.map(val => {
            if (val.Category !== lastName) {
              lastName = val.Category
              this.deviceTypeList.push(val)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
h5{
  text-align: center;
  height:50px;
  line-height: 50px;
  font-size: 16px;
  background: #eef1f6;
  color:#909399;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Slidebar.vue